<template>
    <hr :class="classList" />
</template>

<script>
export default {
    name: 'AppDivider',
    props: {
        hidden: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classList() {
            let classList = ['app-divider'];

            if (this.hidden) {
                classList.push('hidden');
            }

            return classList.join(' ');
        }
    }
};
</script>

<style lang="scss" scoped>
.app-divider {
    display: block;
    border: 0;
    height: 1px;
    width: 100%;
    background: var(--v-background-darken3);
}
</style>
